import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { PushPayExcludedLines } from "./pushpay-excluded-lines";
import { useStAdjustmentsSection } from "./st-adjustments-section";

export const StAdjustmentsHeader = () => {
  const { totals, warnings, selection } = useStAdjustmentsSection();

  if (!totals) return null;

  return (
    <Stack
      direction="row"
      align="center"
      justify="between"
      fullWidth
      gap="md"
      className="shrink-0 flex-wrap gap-y-3 border-b border-stroke-tertiary px-4 py-3"
    >
      <Stack gap="xs" className="min-w-0">
        <Typography variant="subtitleW3">
          {totals.pending === totals.count
            ? `${totals.pending} lines to push`
            : `${totals.pending} of ${totals.count} lines to push`}
        </Typography>
        <Typography variant="captionW1" textColor="tertiary">
          {selection.hasSelection
            ? `${selection.selectedGroups.length} of ${selection.pushableGroups.length} technicians selected`
            : `${selection.pushableGroups.length} technicians with lines pending`}
        </Typography>
      </Stack>
      <Stack gap="xs" align="end" className="min-w-0 text-right">
        <Typography variant="captionW1" textColor="tertiary">
          Amounts reflect the current Grid status. Manually added lines will not
          be included in push.
        </Typography>
        <PushPayExcludedLines warnings={warnings} />
      </Stack>
    </Stack>
  );
};
